import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Lock, User, LogIn } from 'lucide-react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import { doSignInWithEmailAndPassword } from '../firebase/authentication';



const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate(); // Initialize useNavigate

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        if (!email || !password) {
            setError('Please fill in all fields.');
            setIsLoading(false);
            return;
        }

        try {
            const userCredential = await doSignInWithEmailAndPassword(email, password);
            // The user is logged in.
            const user = userCredential.user;
            console.log('Login successful', user);
            navigate('/'); // Redirect on successful login
        } catch (error) {
            // Handle errors.
            let errorMessage = 'An error occurred during login.';
            if (error.code === 'auth/user-not-found') {
                errorMessage = 'User not found. Please check your email.';
            } else if (error.code === 'auth/wrong-password') {
                errorMessage = 'Invalid password. Please try again.';
            } else if (error.code === 'auth/invalid-email') {
                errorMessage = "Invalid email address."
            }
            setError(errorMessage);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-900 to-indigo-900"
        >
            <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.3, delay: 0.2 }}
                className="w-full max-w-md bg-white/10 backdrop-blur-md rounded-xl shadow-lg p-8 border border-white/10"
            >
                <h2 className="text-2xl font-semibold text-white mb-6 text-center">
                    <LogIn className="inline-block w-6 h-6 mr-2" />
                    Login
                </h2>
                <form onSubmit={handleSubmit} className="space-y-6">
                    <div>
                        <label htmlFor="email" className="text-gray-300">Email</label>
                        <div className="relative">
                            <User className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                            <input
                                type="email"
                                id="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="Enter your email"
                                className="pl-10 pr-4 py-2 bg-black/20 text-white border-gray-700 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent rounded-md w-full"
                                disabled={isLoading}
                            />
                        </div>
                    </div>
                    <div>
                        <label htmlFor="password" className="text-gray-300">Password</label>
                        <div className="relative">
                            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
                            <input
                                type="password"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="Enter your password"
                                className="pl-10 pr-4 py-2 bg-black/20 text-white border-gray-700 placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent rounded-md w-full"
                                disabled={isLoading}
                            />
                        </div>
                    </div>
                    {error && (
                        <p className="text-red-500 text-sm mt-2">{error}</p>
                    )}
                    <button
                        type="submit"
                        className="w-full py-2.5 bg-indigo-500 text-white rounded-md transition-colors duration-300 hover:bg-indigo-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            'Logging in...'
                        ) : (
                            'Login'
                        )}
                    </button>
                </form>
                <div className="mt-6 text-center">
                    <a href="#" className="text-sm text-gray-400 hover:text-white transition-colors">
                        Forgot Password?
                    </a>
                </div>
                {/* <div className="mt-4 text-center">
                    <p className="text-sm text-gray-400">
                        Don't have an account?{' '}
                        <a href="/register" className="text-indigo-400 hover:text-indigo-300 transition-colors">
                            Register
                        </a>
                    </p>
                </div> */}
            </motion.div>
        </motion.div>
    );
};

export default LoginPage;
